if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', function () {
		initValidation();
	});
} else {
	initValidation();
}

function initValidation(){
	for (let input of document.querySelectorAll('.js-custom-forms input')) {
		input.oninvalid = function(e) {
			e.preventDefault();
			input.closest('.js-form-field').querySelector('.js-error').style.display = 'block';
			input.classList.add('!border-red')
		};
		input.oninput = function(e) {
			input.closest('.js-form-field').querySelector('.js-error').style.display = 'none';
			input.classList.remove('!border-red')
		};
	}

}
